var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStorePolicy = function SvgStorePolicy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 90,
    viewBox: "0 0 93 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.3794,
    y: 1.85156,
    width: 54.1158,
    height: 69.3956,
    rx: 5.09325,
    transform: "rotate(43.3166 53.3794 1.85156)",
    fill: "url(#paint0_linear_933_3824)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5071 11.3942C51.7132 10.1151 53.7279 10.0559 55.007 11.2619L83.2631 37.9046C84.5422 39.1107 84.6014 41.1254 83.3954 42.4045L49.3277 78.5353C47.398 80.5819 44.1745 80.6766 42.1279 78.7469L15.2614 53.4145C13.9823 52.2084 13.9231 50.1937 15.1292 48.9146L50.5071 11.3942Z",
    fill: "url(#paint1_linear_933_3824)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5071 11.3942C51.7132 10.1151 53.7279 10.0559 55.007 11.2619L83.2631 37.9046C84.5422 39.1107 84.6014 41.1254 83.3954 42.4045L60.6836 66.4917C52.4821 75.1898 38.7824 75.5924 30.0843 67.391L15.2614 53.4145C13.9823 52.2084 13.9231 50.1937 15.1292 48.9146L50.5071 11.3942Z",
    fill: "url(#paint2_linear_933_3824)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9453,
    y: 19.5469,
    width: 16.5531,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 48.9453 19.5469)",
    fill: "#C2E4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.3784,
    y: 32.2129,
    width: 6.36656,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 62.3784 32.2129)",
    fill: "#C2E4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68.4004,
    y: 37.8906,
    width: 8.91319,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 68.4004 37.8906)",
    fill: "#C2E4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45.8872,
    y: 22.79,
    width: 13.006,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 45.8872 22.79)",
    fill: "#C2E4FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.2764,
    y: 32.5859,
    width: 5.0023,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 56.2764 32.5859)",
    fill: "#C2E4FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60.8428,
    y: 36.8916,
    width: 7.00322,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 60.8428 36.8916)",
    fill: "#C2E4FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42.8306,
    y: 26.0322,
    width: 10.1865,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 42.8306 26.0322)",
    fill: "#C2E4FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 51.6318,
    y: 34.3311,
    width: 15.9164,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 51.6318 34.3311)",
    fill: "#C2E4FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6016,
    y: 46.5605,
    width: 5.72991,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 64.6016 46.5605)",
    fill: "#C2E4FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7725,
    y: 29.2754,
    width: 15.2798,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 39.7725 29.2754)",
    fill: "#C2E4FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 52.2793,
    y: 41.0684,
    width: 7.63988,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 52.2793 41.0684)",
    fill: "#C2E4FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2275,
    y: 47.6191,
    width: 5.72991,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 59.2275 47.6191)",
    fill: "#C2E4FF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7153,
    y: 32.5176,
    width: 10.1865,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 36.7153 32.5176)",
    fill: "#C2E4FF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5166,
    y: 40.8164,
    width: 8.27654,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 45.5166 40.8164)",
    fill: "#C2E4FF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9277,
    y: 47.8047,
    width: 11.4598,
    height: 1.90997,
    rx: 0.954985,
    transform: "rotate(43.3166 52.9277 47.8047)",
    fill: "#C2E4FF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 65.3154,
    y: 9.6084,
    width: 24.8296,
    height: 10.8232,
    rx: 3.18328,
    transform: "rotate(43.3166 65.3154 9.6084)",
    fill: "url(#paint3_linear_933_3824)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30549 23.2787C10.5311 39.1048 21.5421 43.0613 26.3944 43.0613C26.7055 43.0613 27.3277 42.8747 27.3277 42.1282C27.477 31.0798 9.72241 11.6456 0.826425 3.30957C0.142123 3.37178 0.0799138 7.45271 5.30549 23.2787Z",
    fill: "#E4F4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2135 58.9249C33.6583 54.508 28.383 43.0988 19.7234 32.797C11.0639 22.4951 7.03275 15.565 6.09961 13.3877",
    stroke: "#C5E5FF",
    strokeWidth: 1.49302,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_933_3824",
    x1: -0.251884,
    y1: 104.828,
    x2: 91.5818,
    y2: -5.88924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_933_3824",
    x1: -13.9457,
    y1: 25.8752,
    x2: 82.6662,
    y2: 29.1442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDE1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_933_3824",
    x1: -13.9457,
    y1: 25.8752,
    x2: 82.6662,
    y2: 29.1442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_933_3824",
    x1: 45.0136,
    y1: 20.4316,
    x2: 54.1922,
    y2: -3.34396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStorePolicy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "store-policy.04fda114e023ababdcd3d31ab1f55b81.svg";